import React from 'react';
import { Box } from '@chakra-ui/react';
import { Home, HomeOutlined, GridView, GridViewOutlined, Favorite, FavoriteBorder, Person, PersonOutline } from '@mui/icons-material';

// Fixed 64px phone tab bar (design-system.md §3.3). Hidden from md up.
const MobileTabBar = ({ active, onHome, onCategories, onWishlist, onAccount }) => {

    const tabs = [
        { key: 'home', label: 'Home', on: Home, off: HomeOutlined, onClick: onHome },
        { key: 'categories', label: 'Categories', on: GridView, off: GridViewOutlined, onClick: onCategories },
        { key: 'wishlist', label: 'Wishlist', on: Favorite, off: FavoriteBorder, onClick: onWishlist },
        { key: 'account', label: 'Account', on: Person, off: PersonOutline, onClick: onAccount },
    ];

    return (
        <Box as='nav' aria-label='Mobile navigation' display={{ base: 'flex', md: 'none' }} position='fixed' bottom={0} left={0} right={0} height='64px' zIndex={400} bg='raano.white' borderTopRadius='tabbar' boxShadow='tabbar' alignItems='center' justifyContent='space-around' pb='env(safe-area-inset-bottom)' >
            {tabs.map(({ key, label, on: OnIcon, off: OffIcon, onClick }) => (
                <Box key={key} as='button' aria-label={label} aria-current={active === key ? 'page' : undefined} width='64px' height='48px' display='flex' alignItems='center' justifyContent='center' color={active === key ? 'raano.black' : 'blackAlpha.700'} onClick={onClick} >
                    {active === key ? <OnIcon sx={{ fontSize: 28 }} /> : <OffIcon sx={{ fontSize: 28 }} />}
                </Box>
            ))}
        </Box>
    );
};

export default MobileTabBar;
